/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import * as React from 'react';
import grid from '@coop/ole/styles/grid';
import spacing from '@coop/ole/styles/spacing';
import layerTypes from '@coop/ole/styles/layers';
import stacking from '@coop/ole/styles/stacking';
import VisuallyHiddenText from '@coop/ole/VisuallyHiddenText';
import QuartetLogo from '@coop/ole/QuartetLogo';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { colors } from '@coop/ole/styles/colors';
import { AnchorRouterLink } from '@coop/ole/AnchorRouterLink';

import { MarketContext } from 'src/config';
import { trackEvent, Action } from 'src/utils/tracking';
import { scrollToTop } from 'src/components/selfReferralForm/utils/scrollReset';
import { Trans } from '@lingui/macro';

const HeaderContainer = styled.div`
  ${stacking.header}
  ${layerTypes.navigation}
  min-width: 250px;
  width: 100%;
  height: 59px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  top: 0;
  position: sticky;
  padding: 0 ${spacing.md};
  background-color: ${colors.white};
  justify-content: space-between;
  @media (max-width: ${grid.breakpoints.sm}) {
    padding-left: ${spacing.sm};
    padding-right: ${spacing.sm};
  }
  @media (min-width: ${grid.breakpoints.lg}) {
    height: 67px;
  }
`;

const Event = {
  LandingBanner: 'self-referral-getstarted-banner'
};

export const Header = ({ className }: { className: string }) => {
  const { marketId } = React.useContext(MarketContext);
  const location = useLocation();

  return (
    <HeaderContainer className={className}>
      <AnchorRouterLink
        to={`/${marketId}${location.search}`}
        data-test="link-quartet-logo"
        onClick={() => {
          scrollToTop();
          trackEvent(Event.LandingBanner, Action.ClickThrough);
        }}
      >
        <VisuallyHiddenText>
          <Trans>Quartet, find the right care for mental health</Trans>
        </VisuallyHiddenText>
        <QuartetLogo logoFillColor={colors.brandPurple} />
      </AnchorRouterLink>
    </HeaderContainer>
  );
};

export default Header;
